const env = {
  isProd: import.meta.env.VITE_IS_PROD === "1",
  ugTagMasterId: import.meta.env.VITE_APP_UG_MASTER_ID,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  sentryOrg: import.meta.env.VITE_SENTRY_ORG,
};

export default env;
